import axios from 'axios';

// Tatum webhook server base URL - should be configured via environment variable
const TATUM_WEBHOOK_BASE_URL = process.env.REACT_APP_TATUM_WEBHOOK_URL || 'http://localhost:3003';

export interface WebhookLog {
  _id: string;
  request_id: string;
  status: 'success' | 'failed' | 'resolved';
  payload: any;
  response?: any;
  error_message?: string;
  error_type?: string;
  http_status_code?: number;
  processing_time_ms?: number;
  retry_count?: number;
  resolved_at?: string;
  created_at: string;
}

export interface WebhookLogsResponse {
  success: boolean;
  total: number;
  limit: number;
  skip: number;
  logs: WebhookLog[];
}

export interface WebhookStats {
  success: boolean;
  stats: {
    byStatus: Array<{
      _id: string;
      count: number;
      avgProcessingTime: number;
    }>;
    last24Hours: {
      total: number;
      failed: number;
      successRate: string;
    };
  };
}

export interface RetryWebhookResponse {
  success: boolean;
  message: string;
  requestId: string;
  response?: any;
  processingTimeMs?: number;
  error?: string;
}

/**
 * Get webhook logs with optional filters
 */
export const getWebhookLogs = async (
  status?: string,
  limit: number = 100,
  skip: number = 0
): Promise<WebhookLogsResponse> => {
  const params: any = { limit, skip };
  if (status && status !== 'all') {
    params.status = status;
  }

  const response = await axios.get(`${TATUM_WEBHOOK_BASE_URL}/admin/webhook-logs`, {
    params,
  });

  return response.data;
};

/**
 * Get webhook statistics
 */
export const getWebhookStats = async (): Promise<WebhookStats> => {
  const response = await axios.get(`${TATUM_WEBHOOK_BASE_URL}/admin/webhook-stats`);
  return response.data;
};

/**
 * Retry a failed webhook
 */
export const retryWebhook = async (requestId: string): Promise<RetryWebhookResponse> => {
  const response = await axios.post(`${TATUM_WEBHOOK_BASE_URL}/admin/retry-webhook/${requestId}`);
  return response.data;
};

/**
 * Get health status of Tatum webhook server
 */
export const getWebhookHealth = async () => {
  const response = await axios.get(`${TATUM_WEBHOOK_BASE_URL}/health`);
  return response.data;
};

